import { di } from "@/client/di/di";

import { AdvancedStore, BaseStoreProps } from "@/stores/createAdvancedStore";

import { PaymentModalApi } from "./types";

//

export interface PaymentSystemStoreProps extends BaseStoreProps {
  paymentModalApi: PaymentModalApi;
}

export type PaymentSystemStore = AdvancedStore<PaymentSystemStoreProps>;

//

export const paymentSystemStore = di.resolve_core("PaymentSystemStore");
export const usePaymentSystemStore = paymentSystemStore.useContext;
